<template>
  <div>
    <Header />
    <MarketPlace
      title="The best graded produce available at scale from local farmers."
    />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import MarketPlace from "@/components/MarketPlace.vue";

export default {
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | MarketPlace",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: { Header, Footer, MarketPlace }
};
</script>
